import React from 'react';
import {Stack, Typography, Divider} from '@mui/material';

import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {OdontoSuggestionSpecialtyProps} from './types';
import {SUGGESTED_SPECIALTY} from 'presentation/modules/booking/shared/constants/suggestedSpecialty';
import {OdontoCard} from '../OdontoCard';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';

const {suggestedSpecialties} = translations['pt-br'].privateFlow.bookingFlow.specialtyFlow;

export function OdontoSuggestionSpecialty({
	handleSelectCard,
	suggestionSpecialty,
}: OdontoSuggestionSpecialtyProps) {
	const {
		beneficiary: {idadeC},
	} = useAccountDataStore(state => state.accountData);

	const isPediatric = idadeC < 18;
	const suggestionTitle = isPediatric
		? SUGGESTED_SPECIALTY.generalPediatricOdonto.formattedText
		: SUGGESTED_SPECIALTY.generalAdultOdonto.formattedText;

	const specialtyFormatted = formatText(suggestionTitle);

	return (
		<Stack gap={2}>
			<Typography variant="subheader">{suggestedSpecialties}</Typography>
			<OdontoCard
				dataTagId={AppointmentBookingEnum.SELECIONOU_ESPECIALIDADE_SUGERIDA}
				text={specialtyFormatted}
				handleClick={() => handleSelectCard(suggestionSpecialty!)}
			/>

			<Divider />
		</Stack>
	);
}
